module.exports = __webpack_public_path__ + "img/weather_Y.3371acde.png";